export default "__VITE_ASSET__24a2f584__"